import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services';
import { environment } from './../../../environments/environment';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { config, CognitoIdentityCredentials, CognitoIdentityServiceProvider } from 'aws-sdk'
import { DialogService } from '../../services/dialog/dialog.service';
import { ChangePasswordChallengeComponent } from '../change-password-challenge/change-password-challenge.component';
import { COGNITO_ERROR_INVALID_PARAMETER_EXCEPTION, COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION, COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION, COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION, COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION } from '../../utils/constant';
import { LanguageService } from 'src/app/services/language/language.service';
import { LoginService } from './login.service';
import { catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { of as observableOf } from 'rxjs';
import { NoWhiteSpaceValidator } from 'src/app/utils/validators/nowhitespace.validator';

@Component({
  selector: 'esc-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public isPasswordShown: boolean;
  public isSubmitting : boolean;
  public loginForm : UntypedFormGroup;
  public errorMessage: String;
  isLoggedIn: boolean;
  deconsolidatorList = [];
  imgUrl = "../../../assets/images/escience-logo.png"

  constructor(
    private fb: UntypedFormBuilder, 
    private route: ActivatedRoute, 
    private dialogService: DialogService,
    private router: Router, 
    private authService: AuthService,
    private languageService: LanguageService,
    private loginService: LoginService,
  ){}

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: [null, [Validators.required, NoWhiteSpaceValidator]],
      password: [null, Validators.required],
      rememberMe: [false]
    });


    this.route.queryParams.subscribe(params => {
      if(params['username']){
        this.loginForm.controls['username'].setValue(params['username']);
      }
    });
  }

  onSubmit(value: any){
 
    this.isSubmitting = true;
    this.loginForm.disable();


    let authenticationDetails = new AuthenticationDetails({
      Username: _.trim(value.username),
      Password: value.password
    });
    
    let cognitoUser = new CognitoUser({
      Username : _.trim(value.username),
      Pool : this.authService.userPool      
    });
    
    let self = this;
    

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (session) {
        self.authService.initAWSCredentials();
        self.getUserData();
        self.isLoggedIn = true;
        self.isSubmitting = false;
        sessionStorage.setItem("sessionData", "loggedIn");
      },
      onFailure: function (err) {
        console.log(err);
        self.isSubmitting = false;
        self.loginForm.enable();

        switch(err.name){
          case COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION:
          case COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION:
            self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_USERNAME_PASSWORD_INCORRECT",{});
            break;
          case COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION:
            // TODO: SEND_RESET_PASSWORD_REQUIRED
            // TODO: ERROR_MESSAGE_ABOVE
            self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_USERNAME_PASSWORD_INCORRECT",{});
            break;
          case COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION:
            // TODO: ERROR_MESSAGE_ABOVE
            self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_VERIFY_ACCOUNT",{});
            break;
          case COGNITO_ERROR_INVALID_PARAMETER_EXCEPTION:
            self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_USERNAME_PASSWORD_INCORRECT",{});
            break;
          default: 
          // TODO: ERROR_MESSAGE_ABOVE
          self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_DEFAULT",{});
            
        }
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        self.isSubmitting = false;
        delete userAttributes.phone_number_verified;
        delete userAttributes.email_verified;
        delete userAttributes.email;
        self.dialogService.openDialog(ChangePasswordChallengeComponent, { 
            width: "400px", 
            autoFocus: true,  
            disableClose: true, 
            data: {
              session: this
            }
          })
          .afterClosed()
          .subscribe((password) => {
            self.isSubmitting = true;
            cognitoUser.completeNewPasswordChallenge(password, userAttributes, this);
          });
      }
    })
  }

  getUserData(){
    this.loginService.getUserData(null).pipe(
      catchError( (err)=>{ 
       console.log(err)
       return observableOf(err)
      })
    ).subscribe((res)=>{
      if(res == null || res.error?.value == "Unknown Error" || res.error?.count > 0 ){
        this.authService.logout();
        this.dialogService.openSnackBar(this.languageService.getTranslation('MESSAGE_ERROR_UNAUTHORIZED',null));
        this.isLoggedIn = false;
        this.isSubmitting = false;
        this.loginForm.enable();
      } else if(res.success?.count > 0){
        if(res.success.results.deconsolidator_count === 1){
          localStorage.setItem('selectedConsolidator', JSON.stringify(res.success.results.deconsolidator_details[0].code.toString()));
          this.deconsolidatorList = [];
          this.proceedLogin();
        } else {
          this.deconsolidatorList = res.success.results.deconsolidator_details
          this.loginService.setConsolidatorMapping(this.deconsolidatorList)
        }
        this.authService.storeSettings(res)
      }
    })
  }

  proceedLogin(){
    this.router.navigate(['/']);
  }

  onWarehouseSelect(data) {
    if (data) {
      localStorage.setItem('selectedConsolidator', JSON.stringify(data.code.toString()));
      // this.authService.setEndpoint();
      this.proceedLogin();
    }
    else {
      this.loginForm.enable();
      this.isSubmitting = false;
      this.isLoggedIn = false;
      this.deconsolidatorList = []
      this.authService.logout();
    }
  }
}

